<template>
  <SfModal
    size="xxl"
    :content-padding="0"
    :scrollable-content="false"
    class-name="sf-assistant-checks-modal"
    content-class-name="tw-flex-1 tw-min-h-0 tw-flex tw-flex-col"
    @close="$emit('close')"
  >
    <template #title>
      {{ I18n.t('assistant_check.modal.title') }}
    </template>
    <template #body>
      <div
        class="
          tw-border-0
          tw-border-t
          tw-border-b
          tw-border-solid
          tw-border-sf-neutral-lighter-2
          tw-px-6
          tw-py-3
        "
      >
        <AssistantChecksFilters />
      </div>
      <div
        class="
          tw-flex-1
          tw-min-h-0
          tw-bg-sf-snow
          tw-flex
          tw-justify-center
          tw-px-12
          tw-py-6
          tw-rounded-b-lg
        "
      >
        <div
          class="
            tw-w-full
            tw-max-w-condensed-content
            tw-bg-white
            tw-rounded-lg
            tw-border
            tw-border-solid
            tw-border-sf-neutral-lighter-2
            tw-overflow-hidden
          "
        >
          <SfAssistantChecksPage :context-id="undefined" in-modal />
        </div>
      </div>
    </template>
  </SfModal>
</template>

<script setup lang="ts">
import { SfModal } from '@app/shared/vue/components/sf-modal'
import SfAssistantChecksPage from './sf-assistant-checks-page.vue'
import AssistantChecksFilters from './assistant-checks-filters.vue'
import useI18n from '@app/shared/vue/composables/use-I18n'

defineOptions({
  name: 'SfAssistantChecksModal',
})

defineEmits(['close'])

const I18n = useI18n()
</script>

<style scoped>
.sf-assistant-checks-modal :deep(.sf-modal-header .sf-modal-title) {
  flex: 1;
  text-align: center;
}
</style>
